import { Form} from "antd";
import styled from "styled-components";

export const CommentDrawerContentApprovalForm = styled(Form)`
  height: 100%;

  .content-decision-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .ant-radio-wrapper {
      width: 100%;
    }
  }

  .ant-form-item-label > label {
    height: 20px;
  }
`;

export const CommentFullEngineerInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  > .comment-full-engineer-info:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const Wrapper = styled.div<{ $iconColor: string }>`
  .engineer-item-text-col ~ .ant-col {
    max-width: 132px;
    text-align: end;

    .approved-item > .ant-col {
      > .anticon {
        color: ${(props) => props.$iconColor};
      }

      > .ant-typography {
        font-weight: 500;
      }
    }

    .approve-button {
      height: 24px;
    }

    .engineer-item-clock-icon {
      color: ${"#bfbfbf"};
    }
  }
`;
